/**
 * @generated SignedSource<<70351a06eccbff6929af7fe0c0f7f725>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Media_Url_Fragment$data = {
  readonly description: string | null | undefined;
  readonly id: string;
  readonly mediaDetails: {
    readonly sizes: ReadonlyArray<{
      readonly name: string | null | undefined;
      readonly sourceUrl: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly mediaItemUrl: string | null | undefined;
  readonly mimeType: string | null | undefined;
  readonly " $fragmentType": "Media_Url_Fragment";
};
export type Media_Url_Fragment$key = {
  readonly " $data"?: Media_Url_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"Media_Url_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Media_Url_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaItemUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mimeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaDetails",
      "kind": "LinkedField",
      "name": "mediaDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MediaSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sourceUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "MediaItem",
  "abstractKey": null
};

(node as any).hash = "b92de68bf6804da923db0af03724c151";

export default node;
